<template>
  <div class="cg-theme-bg md:pt-48 pb-10 pt-20 lg:px-10 md:px-8 px-5 relative">
    <div class="absolute top-0 left-0">
      <img src="../../../img/tl-cd.svg" alt="bg" />
    </div>
    <div class="absolute bottom-0 right-0">
      <img src="../../../img/br-cd.svg" alt="bg" />
    </div>
    <div class="flex container">
      <div class="md:w-4/6 w-full">
        <h1 class="fsize40 sm-fsize20 font-bold text-black">
          <!-- Adobe Photoshop CC: Your Complete Beginner to Advanced Class -->
          {{ selectedCourseHome.name }}
          <!-- Static Clean Your Wound Correctly -->
        </h1>
        <p class="font-medium fsize1-2 text-black mt-4">
          <!-- There are many of passages of Lorem Ipsum available, but the majority
          have suffered in some form, by injected humour, or words which don't
          look even slightly. If you are going to use a passage of Lorem Ipsum,
          you need to be sure there isn't anything hidden in the middle of text. -->
          {{ selectedCourseHome.description }}
          <!-- Staic Open wounds are a portal of infection. The longer a wound stays
          open the worse the resulting scar will be. Cleaning a wound is the
          first step in caring for a wound. Appropriate cleaning is a critical
          often overlooked step. In many instances, people are using cytoxic
          cleansers that can cause more harm than good and slow the entire
          process. -->
        </p>

        <div class="lg:flex md:flex mt-8 md:flex-wrap">
          <div class="lg:w-1/4 md:w-1/2 lg:mb-0 mb-4">
            <p class="text-black font-semibold fsize20 sm-fsize18">Category</p>
            <p class="text-black font-semibold fsize16 sm-fsize14">
              <!-- Web Development -->
              {{
                selectedCourseHome.category.map((data) => data.name).toString()
              }}
              <!-- First Aid -->
            </p>
          </div>

          <div class="lg:w-1/4 md:w-1/2 lg:mb-0 mb-4">
            <p class="text-black font-semibold fsize20 sm-fsize18">
              Course Level
            </p>
            <p class="text-black font-semibold fsize16 sm-fsize14">
              {{ selectedCourseHome.level }}
              <!-- Medium -->
            </p>
          </div>

          <div class="lg:w-1/4 md:w-1/2 lg:mb-0 mb-4">
            <p class="text-black font-semibold fsize20 sm-fsize18">Duration</p>
            <p class="text-black font-semibold fsize16 sm-fsize14">
              {{ selectedCourseHome.duration }} hrs
              <!-- 3.5 hrs -->
            </p>
          </div>

          <div class="lg:w-1/4 md:w-1/2 lg:mb-0 mb-4">
            <p class="text-black font-semibold fsize20 sm-fsize18">Chapters</p>
            <p class="text-black font-semibold fsize16 sm-fsize14">
              {{ selectedCourseHome.chapter.length }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("eLearning", ["selectedCourseHome"]),
  },
};
</script>
